import { render, staticRenderFns } from "./ProductionClassificationStatistics.vue?vue&type=template&id=13d16a32&scoped=true&"
import script from "./ProductionClassificationStatistics.vue?vue&type=script&lang=js&"
export * from "./ProductionClassificationStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ProductionClassificationStatistics.vue?vue&type=style&index=0&id=13d16a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d16a32",
  null
  
)

export default component.exports